var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateArrowSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 10 10",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0 -1 1 0 -1 11)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.555555 3.722285v-1.72408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.279635 1.998205h-1.72408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.701225 2.34483c1.73488555.82221157 2.6463492 2.75632997 2.1761218 4.61771278-.47022738 1.86138281-2.19091589 3.13056012-4.10814838 3.03016407-1.91723248-.10039601-3.49595259-1.54234702-3.76919842-3.44266185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.3296 1.998235c-.00001657.01379864-.01120967.02497458-.02500833.02496997-.01379865-.0000046-.02498429-.01118801-.02499165-.02498666s.01116634-.02499398.02496498-.02501331c.00664168-.0000093.01301407.00262463.01771092.00732054s.00733206.01106778.00732408.01770946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.55182 2.6649c-.00001657.01379929-.01121068.0249755-.02500999.02496998-.0137993-.00000552-.02498447-.01119069-.02498999-.02498999-.00000552-.01379931.01117069-.02499342.02496998-.02500999.00664081-.00000797.01301192.00262655.01770769.00732231.00469576.00469577.00733028.01106688.00732231.01770769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.225 4.22046c-.00001933.01379864-.01121466.02497234-.02501331.02496498s-.02498206-.011193-.02498666-.02499165c-.00000461-.01379866.01117133-.02499176.02496997-.02500833.00664168-.00000798.01301355.00262723.01770946.00732408s.00732984.01106924.00732054.01771092"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 12v-12h12v12z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowSecond);
export default __webpack_public_path__ + "static/media/rotate-arrow-second.422fed0e2443db3cd5795b12d187318b.svg";
export { ForwardRef as ReactComponent };